var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25,45.804c-10.891,0-19.75-8.859-19.75-19.75S14.109,6.304,25,6.304s19.75,8.859,19.75,19.75-8.859,19.75-19.75,19.75Zm0-36c-8.96,0-16.25,7.289-16.25,16.25s7.29,16.25,16.25,16.25,16.25-7.289,16.25-16.25-7.29-16.25-16.25-16.25Z",
    fill: "currentColor",
    strokeWidth: "0px"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.255,
    y: 22.551,
    width: 3.49,
    height: 13.078,
    fill: "currentColor",
    strokeWidth: "0px"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.255,
    y: 16.401,
    width: 3.49,
    height: 3.35,
    fill: "currentColor",
    strokeWidth: "0px"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInfo);
export default __webpack_public_path__ + "static/media/icn-info.36e18b530c0944e0d2a36d9723673954.svg";
export { ForwardRef as ReactComponent };